import React from "react";

import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";

export default function ({ heading, description, id }) {
    return <Box className={`CampaignSection CampaignSectionContainer-${id}`}>
        <Container>
            <Typography variant="h4" align="center" gutterBottom>{heading}</Typography>
            <Typography className="Description"  dangerouslySetInnerHTML={{__html: description}}></Typography>
        </Container>
    </Box>
}